/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{4133C86A-67E3-4EB1-8D3F-368C56DDA5C7}",
  "sitecoreApiHost": "",
  "jssAppName": "Nomura",
  "scSite": "Nomura",
  "defaultLanguage": "ja-JP",
  "graphQLEndpointPath": "/api/Nomura",
  "graphQLEndpoint": "/api/Nomura?sc_apikey={4133C86A-67E3-4EB1-8D3F-368C56DDA5C7}"
};